export const formatPrice = (number, eur, withOutCurrency) => {
  if (number === null || number === undefined || number === '') return '';

  const parsedNumber =
    typeof number === 'string'
      ? parseFloat(
        number
          .replace(/\s/g, '')   // szóköz törlés
          .replace(/\./g, '')   // ezres pont törlés (ha van)
          .replace(',', '.')    // tizedes vessző → pont
      )
      : number;

  if (isNaN(parsedNumber)) return '';

  if (!withOutCurrency) {
    return parsedNumber.toLocaleString('hu-HU', {
      style: 'currency',
      currency: eur ? 'EUR' : 'HUF',
      minimumFractionDigits: 0,
      maximumFractionDigits: eur ? 2 : 0,
      useGrouping: true,
    });
  }

  return parsedNumber.toLocaleString('hu-HU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: eur ? 2 : 0,
    useGrouping: true,
  });
};